module.exports = __webpack_public_path__ + "img/u1222.2497455e.svg";